appHost.actions.register({
    // #region Vars
    name: '288a.entity.select',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Args
        let tArgs = {
            entity: params.entity,
            owner: undefined,
            viewName: "select",
            mode: "common",
            args: {
                data: data,
                ...params,
            }
        };
        // #endregion
        // #region Instance
        if (data && data.__g_isproxy) {
            tArgs.owner = data;
        }
        // #endregion
        // #region Debug
        utils.logDebug("action: 288a.entity.select", {
            data: data,
            params: params,
            args: tArgs,
        });
        // #endregion
        // #region Show
        let tWindow = {
            variant: params?.w ?? 'popup',
            position: params.l,
            size: params.s ?? 'xlarge',
        };
        //Show
        let tResult = await this.$appHost.notification.showModal2('g-layout__layout-entity', tArgs, tWindow);
        {
            if (tResult.state !== 1) {
                return this.Cancel();
            }
        }
        //Finish
        return this.Ok(tResult.result);
        // #endregion
    },
    // #endregion
});
export {};
